import fn_core from '../../frontend/src/fn_core';

class fn extends fn_core {
   reqout_korcsop(e) {
      var row = $(e.currentTarget);
      var d = engine.fn.korcsop_count(row);
      if (!d.ksz && !d.nsz) row.trigger('rowError', 'req');
   }
   korcsop_count(row) {
      var ki = [0, 3, 14, 16],
         na = [18, 31, 60, 65, 70, 76, 80],
         ksz = 0, nsz = 0, id;
      $.each(row.rVal(), function (k, v) {
         v = parseInt(v);
         if (v > 0) {
            id = parseInt(k.split('korcsop_')[1]);
            if ($.inArray(id, ki) != -1) ksz += v;
            else if ($.inArray(id, na) != -1) nsz += v;
         }
      });
      return {ksz: ksz, nsz: nsz};
   }
   korcsop_init(row) {
      row.find('input').on('change', function () {
         var d = engine.fn.korcsop_count(row);
         if ((d.nsz == 1 || d.nsz == 2) && d.ksz >= 1) $('#tb_csalad').showRow();
         else $('#tb_csalad').hideRow();
      }).on('keypress', engine.fn.only_number);
      var d = engine.fn.korcsop_count(row);
      if ((d.nsz == 1 || d.nsz == 2) && d.ksz >= 1) $('#tb_csalad').showRow();
      else $('#tb_csalad').hideRow();
   }

    kieg_process() {
        $('.ui-block-b').removeClass("ui-disabled");
        $('.ui-block-b').addClass("ui-disabled");
        $('.loading_value').text('A biztosító nem adott díjat!');
        var d = {};
        $.each(engine.rowmap, function (i, did) {
            if (did.indexOf('kieg_') !== 0)
                return;
            d[did] = $('#tb_' + did).rVal()
        });
        d.async = 0;
        $('#tb_kiegDij').cmd('kiegProc', d); // bármelyik kieg row jó
        engine.fn.basket_change();
    }
    kieg_show(row, d) {
        $('.ui-block-b').removeClass("ui-disabled");
        //$('.ui-block-b').addClass("ui-disabled");
        if (typeof d == 'object' && d.success) {
            //$('.ui-block-b').removeClass("ui-disabled");
            row.find('.loading_value').removeClass("noprice");
            row.find('.loading_value').text(engine.fn.format1k(d.dij) + ' Ft');
        } else {
            row.find('.loading_value').addClass("noprice");
            row.find('.loading_value').text('A biztosító nem adott díjat!');
        }
        
        if(typeof d == 'object' && !d.success){
           $('.ui-block-b').addClass("ui-disabled");
        }
    }
   basket_change() {
      var val = [];
      val[0] = 'utas';

      var response = engine.ajaxFunc('Basket', val);
      console.log('BASKET:', response);
      if ($('#cartBox').length) {
         $('#cartBox').replaceWith(response.html);
      } else {
         $('#call-back-placeholder').after(response.html);
      }
      console.log('basket_change');
   }

   chk_szer_korcsop(e) {
      $(engine.settings.form.id).on('click','.next', function (e, c) {
          row = $('#tb_szerzodo_szn');
          var o = engine.ajaxFunc('szerzodoSznChk', row.rVal());
          console.log('szerzodoSznChk', o);
          if (o.valid == 1) return;
          var old = engine.row[row.data('id')].inv;
          engine.row[row.data('id')].inv = 20;
          row.showError('inv');
          engine.row[row.data('id')].inv = old;
          return false;
      });
      var row = $(e.currentTarget);
      var o = engine.ajaxFunc('szerzodoSznChk', row.rVal());
      console.log('szerzodoSznChk', o);
      if (o.valid == 1) return;
      row = $('#tb_szerzodo_szn');
      var old = engine.row[row.data('id')].inv;
      engine.row[row.data('id')].inv = 20;
      row.showError('inv');
      engine.row[row.data('id')].inv = old;
   }
   utazok() {

      $('#utazo_adat').on('change', function () {
         change($(this));
      });

      var ws = $('#tb_utazo .child.wrapper');
      var load_error = false;

      ws.on('change', function (e) {
         load_error = false;
         var w = $(e.currentTarget);
         var sel = $('#utazo_adat');
         if (w.data('wid')) {
            unselOpt(sel, w.data('wid'));
         }
         $(this).data({
            empty: 0,
            wid: null
         });
         addDelButt(w);

         optGroup(sel);

         if(load_error){
             $('#utazo_korabbi_utasok_message').html('<b>Korcsoport választás sikertelen!</b>');
             $('#utazo_korabbi_utasok_message').show();
             $('#utazo_korabbi_utasok_message').delay(3000);
             $('#utazo_korabbi_utasok_message').fadeOut(300);
         }
      });

      var addDelButt = function (w) {
         if (w.find('.ui-icon-delete').length) return;

         var a = $("<a href='#' class='ui-btn ui-icon-delete ui-btn-icon-notext'></a>");
         w.prepend(a);
         a.on('click', function () {
            loadDom(w);
         });
      }

      $('#tb_utazo .child.wrapper[data-empty=0]').each(function () {
         addDelButt($(this));
      });

      var change = function (sel) {
         var s = stat();
         var rem = $.extend({}, s.wids);
         var get = [];

         $.each(sel.val(), function (i, wid) {
            delete(rem[wid]);
            if (typeof s.wids[wid] != 'undefined') return; // már be van töltve
            get.push(wid); // feltöltendő
         });

         if ($(rem).length) {
            $.each(rem, function (wid, w) {
               loadDom($(w));
               s.free++;
            });
         }

         if (s.free < get.length) {
            noAvailAlert();
            var ng = [];
            var a = false;
            $.each(get, function (i, wid) {
               if (ng.length >= s.free) {
                  unselOpt(sel, wid);
                  return false;
               }
               ng.push(wid);
            });
            get = ng;
         }

         load(sel, get);

         optGroup(sel);
      }

      var stat = function () {
         var s = {};
         s.wids = {};
         s.free = 0;
         $.each(ws, function (i, w) {
            var d = $(w).data();
            if (d.empty) s.free++;
            else if (d.wid) s.wids[d.wid] = w;
         });
         return s;
      }

      var load = function (sel, wids) {
         if (!wids.length) return;

         var d = {
            va: wids,
            async: true
         };
         sel.closest('.row').cmd('load', d, function (row, ret) {
            if (!ret.c) return
            $.each(ret.u, function (wid, u) {
               loadDom(getFree(), u);
            });
         });
      };

      var unselOpt = function (sel, wid) {
         sel.find('option[value=' + wid + ']').prop('selected', false);
         sel.selectmenu('refresh');
      };

      var loadDom = function (w, d) {
         load_error = true;
         if (w === false) return false;
         var t = typeof d == 'object', s;

         s = w.find("[name$='titulus']");
         s.closest('.row').rVal(t ? d.tit : '-');
         s.trigger('change');
         w.find("[name$='vezeteknev']").val(t ? d.vn : '');
         w.find("[name$='keresztnev']").val(t ? d.kn : '');
         s = w.find("[name$='neme']");
         s.closest('.row').rVal(t ? d.s : '-');
         s.trigger('change');
         w.find("[name$='anyjaneve']").val(t ? d.an : '');
         w.find("[name$='szn']").closest('.row').rVal(t ? d.sz : '');
         s = w.find("[name$='tipus']");
         s.closest('.row').rVal(t ? d.t : '-');
         s.trigger('change');
         w.find("[name$='igszam']").val(t ? d.ai : '');
         w.find("[name$='utlevel']").val(t ? d.au : '');

         w.data({
            wid: t ? d.id : null,
            empty: t ? 0 : 1
         });

         if (t) {
             addDelButt(w);
             $('#utazo_korabbi_utasok_message').html('<b>Korcsoport választás sikeres.</b>');
             $('#utazo_korabbi_utasok_message').show();
             $('#utazo_korabbi_utasok_message').delay(3000);
             $('#utazo_korabbi_utasok_message').fadeOut(300);
         } else {
             w.find('.ui-icon-delete').remove();
         }

         w.find('.row').removeClass('v error inv req').find('.error_msg').remove();

         load_error = false;

         return true;
      }

      var getFree = function () {
         var ret = false;
         $.each(ws, function (i, w) {
            if ($(w).data('empty')) {
               ret = w;
               return false;
            }
         });
         return ret ? $(ret) : false;
      }

      var noAvailAlert = function () {
         var a = $('.utazoknosp');
         if (a.length != 2) {
            a = $("<div class='utazoknosp'>## nincs több hely, töröljön</div>");
            a.appendTo('#utazo_adat-listbox-popup,#utazo_adat-dialog .ui-dialog-contain');
         }
         a.fadeIn(300).delay(1000).fadeOut(300);
      }

      var optGroup = function (sel) {
         $.each(sel.find('optgroup'), function () {
            var g = $(this);
            if (g.data('max') <= g.find('option:selected').length) {
               g.find('option:not(:selected)').prop('disabled', true);
            } else {
               g.find('option').prop('disabled', false);
            }
         });
         sel.selectmenu('refresh');
      }
   }
   assistance_data_show(e) {
      //ha ez kell át kell írni
//      console.log('assistance_data_show');
//      return;
      /*$('[name^="utazas_eszkoze["]').on('change', function(){
       $('#tb_uticel select').change();
       });
       $('#assistance1').on('change', function(){
       $('#tb_uticel select').change();
       });
       $('#tb_uticel select').on('change',function(){*/
      var uticel = $('#uticelok').val();
//      console.log('uticel', uticel);
      var jarmuvek_szama = 0;
//      if ($('#jarmuvek_szama').is(":visible")) jarmuvek_szama = $('#jarmuvek_szama').val();
//
      $('#tb_assistance').show();
//      //$('#tb_jarmuvek_szama').show();
//      $('#tb_jarmu').show();
//
//      if (!$('#jarmuvek_szama').is(":visible")) $('#tb_jarmuvek_szama').hide();
//
//      var jarmuCount = 0;
//      $('[id^="tb_jarmu_"]').each(function () {
//         jarmuCount++;
//         if (jarmuCount <= jarmuvek_szama) $(this).show();
//      })

      var assistance = [];
      $('[name^="utazas_eszkoze["]').each(function () {
         if ($(this).is(':checked')) assistance.push($(this).val());
      });
      
      if (uticel !== null) {
           var o = engine.ajaxFunc('assistance_data_show', {'uticel' : uticel});
//           console.log('uticel', uticel, 'uticel ajax', o);
           if (o.show) {
               $('#tb_assistance').show();
               if ($('#assistance').val() == 1) {
                   $('#tb_assistance_rep').show();
               }
           }
           else {
               $('#tb_assistance').hide();
               $('#tb_assistance_rep').hide();
           }
      } else {
           $('#tb_assistance').hide();
           $('#tb_assistance_rep').hide();
      }
      if (jQuery.inArray('auto', assistance) == -1 && jQuery.inArray('motor', assistance) == -1) {
         $('#tb_assistance').hide();
         $('#tb_assistance_rep').hide();
      }

      $('#uticelok').on('change', function (e) {
          e.preventDefault();
          $('#uticelok option:selected').prependTo('#uticelok');
          $('#tb_uticelok').find('select').selectmenu().selectmenu('refresh', true);
          $('html, body').animate({ scrollTop: 0 }, 1);
          e.stopPropagation();
      });
      $(document).ready(function() {
          $('#uticelok option:selected').prependTo('#uticelok');
          $('#tb_uticelok').find('select').selectmenu().selectmenu('refresh', true);
      });

   }
   
   uticel_nem_jav() {
      var uticelok = engine.ajaxFunc('uticel_nem_jav');
      $('#tb_uticelok').find('option').each(function(){
         if ($.inArray($(this).val(), uticelok) > -1) {
             $('#tb_uticelok').find("option[value=" + $(this).val() + "]").attr('disabled', true);
             $('#tb_uticelok').find('select').selectmenu().selectmenu('refresh', true);
         }
      });
   }

   period_default(e) {
      var i_row = $(e.currentTarget);
      var i_date = i_row.rVal();
      i_date = new Date(i_date['y'], i_date['m'] - 1, i_date['d'], 0, 0, 0, 0);
      i_date = engine.fn.formatYMD(i_date);
      var t = $('#tb_period_erkezes');
      var tv = t.find('input');
      var v_date = tv.val();
      if (i_date > v_date) {
          tv.val(i_date);
      }
      if (tv.hasClass('hasDatepicker')) tv.datepicker('option', 'minDate', i_date);
   }

    szemelyesDijfizetesPopup(e){
        var val = $(e.currentTarget).rVal();;
        if(val == 1){
            var text = '<div data-role="header" role="banner" class="ui-header ui-bar-inherit fizmodinfo">';
               text += '<div>Személyes befizetésre figyelmeztetés</div>';
               text += '<a href="#" data-rel="back" class="ui-btn-right ui-btn ui-btn-a ui-icon-delete ui-btn-icon-notext ui-shadow ui-corner-all" data-role="button" role="button">Bezár</a>';
               text += '</div>';
               text += '<div role="main" class="ui-content assistanceinfo">Ön a díj kifizetésére és az utasbiztosítási kötvények átvételére a személyes ügyintézést választotta, ami azt jelenti, hogy cégünk ügyfélszolgálati irodájába befáradva fizetheti ki és veheti át a kötvényeket (irodáink szombaton és vasárnap nem tartanak nyitva).<br>';
               text += '<br>';
               text += '<a href="http://www.clb.hu/kapcsolat/elerhetoseg" target="_blank">Irodáink elérhetősége >></a></div>';
            engine.popMsg(text);
            e.stopPropagation();
        }
    }
}

export default fn